import React from 'react'
import './Footer.css'
import LogoDesktop from '../../assets/img/FullLogo_Transparent_NoBuffer.webp'

import { MapPin, Phone, Send } from 'lucide-react'
import { useTranslation } from 'react-i18next'
function Footer() {
	const { t } = useTranslation();
	return (
		<footer className='footer'>
			<div className='footer-content'>
				<div className='footer-section presentation'>
					<img
					  src={LogoDesktop}
					  alt="B2BGLOB"
					  className="logo"
					  loading="eager"
					  decoding="async"
					  width="180"
                      height="60"
					/>
					<p className='presentation-text'>
						{t("footer_presentation")}
					</p>
					<p className='sub-text'>
						{t("slogan_subtitle")}
					</p>
				</div>
				<div className='footer-section'>
					<h3> {t("quick_links")} </h3>
					<ul>
						<li>
							<a href='/'> {t("accueil")} </a>
						</li>
						<li>
							<a href='/transporter/signup'>
								{t("link2")}
							</a>
						</li>
						<li>
							<a href='/client/signup'> {t("link3")} </a>
						</li>
						<li>
							<a href='/contact'>Contact</a>
						</li>
					</ul>
				</div>
				<div className='footer-section'>
					<h3> {t("information")} </h3>
					<ul>
						<li>
							<div className='info-item'>
								<MapPin size={16} className='icon' />
								<p>
									74 avenue Gambetta
									<br />
									75020 Paris France
								</p>
							</div>
						</li>
						<li>
							<div className='info-item'>
								<Phone size={16} className='icon' />
								<p>+33 01 45 67 43 22</p>
							</div>
						</li>
					</ul>
				</div>
				{/* Account Section */}
				<div className='footer-section'>
					<h3> {t("my_account")} </h3>
					<ul>
						<li>
							<a href='/login'> {t("my_account1")} </a>
						</li>
						<li>
							<a href='/login'> {t("my_account2")} </a>
						</li>
						<li>
							<a href='/login'>{t("my_account3")}</a>
						</li>
					</ul>
				</div>
				{/* Newsletter Section */}
				<div className='footer-section'>
					<h3> {t("newsletter")} </h3>
					<div className='newsletter-form'>
						<input
							type='email'
							placeholder={t("email")}
							className='newsletter-input'
						/>
						<button className='newsletter-btn'>
							<Send size={18} />
						</button>
					</div>
				</div>
			</div>
			<div className='footer-bottom'>
				<div className='footer-bottom-content'>
					<p>© 2025 B2BGLOB</p>
					<div className='footer-links'>
						<a href='/politique-confidentialite'>
							{t("privacy_policy")}
						</a>
						<span className='separator'>|</span>
						<a href='/cgv'> {t("terms_and_conditions")} </a>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
